import { queryOptions } from '@tanstack/react-query';
import ApiHttpClientService from '@frodo/lib/services/http/base/api-http-client.service';
import { YVES_API_URL } from '@frodo/lib/services/http/shared/constants';
import { MUTATION_KEYS, QUERY_KEYS } from '@frodo/lib/services/http/shared/queryKeys';
import { toUserInfo } from '@frodo/lib/services/http/shared/userInfo.mapper';
import { mutationOptions } from '@frodo/lib/utils/client';
import type {
  LastPurchased,
  LoginInfoResponseType,
  UserInfoType,
} from '@frodo/models/types';

class ApiAccountClientService extends ApiHttpClientService {
  async getLastPurchased(): Promise<LastPurchased[]> {
    return this.get<LastPurchased[]>(YVES_API_URL.lastPurchased);
  }

  async logout(): Promise<boolean> {
    const response = await this.get<LoginInfoResponseType>(YVES_API_URL.logout);

    return response.isAuthenticated;
  }

  async getUserInfo(): Promise<UserInfoType> {
    const response = await this.get<UserInfoType>(YVES_API_URL.userInfo);

    return toUserInfo(response);
  }
}

export const apiAccountClientService = new ApiAccountClientService();

export const userInfoQuery = () => {
  return queryOptions({
    queryKey: QUERY_KEYS.userInfo(),
    queryFn: () => apiAccountClientService.getUserInfo(),
  });
};

export const logoutMutation = () => {
  return mutationOptions({
    mutationKey: MUTATION_KEYS.logout(),
    mutationFn: () => apiAccountClientService.logout(),
  });
};

export const lastPurchasedQuery = () => {
  return queryOptions({
    queryKey: QUERY_KEYS.lastPurchased(),
    queryFn: () => apiAccountClientService.getLastPurchased(),
  });
};
